import clientInfo from 'common/lib/clientInfo';

export default function openCustomerSupport() {
  const siteId = clientInfo.get('site_id');
  const appDashboardPath = siteId
    ? ['admin', 'sites', siteId, 'dashboard'].join('/')
    : ['admin', 'last_site', 'dashboard'].join('/');

  window.open(
    new URL(`${appDashboardPath}?show_help_modal`, window.location.origin).toString(),
    '_blank',
    'noopener',
  );
}
